export type PerformanceDebugLogType = 'Component' | 'Api';

const MaxLogCapacity = 400;

export const getMaxLogCapacity = () => MaxLogCapacity;

export interface PerformanceDebugLogPayload {
  readonly name: string;
  readonly duration?: number;
  readonly traceId?: string;
  readonly requestId?: string;
}

export interface PerformanceDebugLog {
  readonly id: string;
  readonly type: PerformanceDebugLogType;
  readonly payload: PerformanceDebugLogPayload;
}

export interface PerformanceDebugLogs {
  readonly isLoggingEnabled: boolean;
  readonly debugLogs: PerformanceDebugLog[];
}
